import React, { useState, useEffect, useContext } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';
import { ConditionalRender } from '../formControls';

const messageInit = {
    "sentFromUserId": undefined,
    "accountId": undefined,
    "sentToUserId": undefined,
    "sentOn": new Date(),
    "subject": '',
    "message": '',
    "attachments": [],
    "responses": []
}

const CodingEventStartReply = (props) => {
    const [message, setMessage] = useState(messageInit);
    const [codingEvent, setCodingEvent] = useState(null);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [accountId, setAccountId] = useState(null);

    const context = useContext(AuthContext);

    useEffect(() => {
        setMessage(props.message);
    }, [props.message])

    useEffect(() => {
        setCurrentUserId(props.currentUserId);
    }, [props.currentUserId])

    useEffect(() => {
        setCodingEvent(props.codingEvent);
        setAccountId(props.codingEvent.accountId);
        setMessage(props.codingEvent.message);
    }, [props.codingEvent])

    const showMessageModal = () => {
        if (message) {
            showReplyModal(message);
        }
        else {
            showCreateMessageModal();
        }
    }

    const showCreateMessageModal = () => {
        const initModel = {
            sentFromUserId: currentUserId,
            accountId: accountId,
            codingEventId: codingEvent.id
            //sentToUserId: 2
        }
        context.showModal({
            open: true,
            size: 'lg',
            model: initModel,
            closeModal: context.hideModal,
            onSaveCallback: messageChangedCallback,
        }, 'createMessage')
    }

    const showReplyModal = (msg) => {
        const initModel = {
            replyToName: msg.sentFromUser.fullName,
            replyToCompany: msg.sentFromUser.accountName,
            replyToMessage: msg.message,
            replyToSubject: msg.subject,
            "parentMessageId": msg.id,
            // if msg passed in is a root - then it won't have a root id - 
            // if it doesn't have a root id- then the parent must be a
            // root message.
            "rootMessageId": msg.rootMessageId || msg.id,
            "parentMessageId": msg.id,
            "sentFromUserId": currentUserId,
            "sentToUserId": msg.sentFromUserId,
            "accountId": msg.accountId,
            "sentToUserId": msg.sentFromUserId,
            "subject": '',
            "message": '',
            "attachments": [],
            "audience": []
        }
        //createMessageReply
        context.showModal({
            open: true,
            size: 'lg',
            model: initModel,
            closeModal: context.hideModal,
            onSaveCallback: messageChangedCallback,
        }, 'createMessageReply')
    }

    const messageChangedCallback = (msg) => {
        // call the callback if it exists...
        props.messageChangedCallback();
        context.hideModal();
    }
    return (
        <Button variant="primary" size="sm" onClick={() => showMessageModal()}>{codingEvent?.message != null ? 'Reply' : 'Start conversation'}</Button>
    );
}

export default CodingEventStartReply;